import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaBand } from "@/components/CtaBand";
import { BRAND } from "@/config/brand";
import { Placeholder } from "@/components/layout/Section";

export default function Reviews() {
    return (
        <div>
            <PageMeta title="Customer Reviews — YS Removals" description="Real customer reviews of YS Removals will be published here as they are collected." canonical={`https://${BRAND.domain}/reviews`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Reviews" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Customer reviews</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">Real reviews from real customers — we won’t fabricate testimonials.</p>
                </div>
            </section>
            <section className="container-ys section">
                <div className="rounded-2xl border border-dashed border-[#001B3D]/25 bg-white p-8 text-center">
                    <Placeholder>Customer reviews will appear here once collected</Placeholder>
                    <p className="mt-3 text-sm text-[#17252D]/70">If you’ve moved with us, please share your experience — we’d be grateful.</p>
                </div>
            </section>
            <CtaBand />
        </div>
    );
}
